import Link from 'next/link'
import { FunctionComponent } from 'react'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'
import PlatformIcon from '@/components/billboard/top100/content/avatar/platform-icon'
import { KolThumbnail } from '@/components/common/kol-thumbnail'
import routes from '@/hooks/use-authorization/routes'
import { useI18n } from '@/hooks/use-i18n'
import { RankingPlatformType } from '@/types/schema/k6/analyze-api'
import { isPlatformShortcode } from '@/utils/platform/is-platform-shortcode'

interface AvatarProps {
  uuid: string
  platform?: RankingPlatformType
  width?: number
  height?: number
  className?: string
  from?: string
}

const Avatar: FunctionComponent<AvatarProps> = ({
  uuid,
  platform,
  width,
  height,
  className,
  from,
}) => {
  const { locale } = useI18n()
  const platformShortCode =
    platform && isPlatformShortcode(platform) ? platform : undefined

  return (
    <AvatarWrapper className={className} height={height} width={width}>
      <Link
        href={routes.publicKolDetail.stringifyUrl(
          { kolId: uuid },
          { from, platform: platformShortCode, lang: locale },
        )}
      >
        <KolThumbnail imageSize={width ?? 80} kolUuid={uuid} />
      </Link>
      <PlatformIcon platform={platform} />
    </AvatarWrapper>
  )
}

const AvatarWrapper = styled.div<{ width?: number; height?: number }>`
  position: relative;

  ${({ width, height }): FlattenSimpleInterpolation => css`
    height: ${height ?? 80}px;
    width: ${width ?? 80}px;

    svg {
      height: ${height ? height / 3.33 : 24}px;
      width: ${width ? width / 3.33 : 24}px;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 50%);
    }
  `}
`

export default styled(Avatar)``
